// src/components/TrackShipment/TrackShipment.jsx

import React, { useEffect } from "react";
import { Modal, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";

import { faXmark } from "@fortawesome/free-solid-svg-icons";

import "./TrackShipmment.css";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllOrder,
  getProduct,
} from "../../../../features/admin/product/productdetails/Slice";
import { AllOrderStatus } from "../../../../features/admin/common/Slice";

const stepsData = [
  {
    title: "Order Confirmed",
    desc:
      "We have received your order and it is being prepared for processing.",
    status: "done",
    time: "Oct 24, 2026 12:30 PM",
  },
  {
    title: "Order Processing",
    desc:
      "Your order has been shipped and handed over to our delivery partner.",
    status: "active",
  },
  {
    title: "Delivered",
    desc: "Your Order Has Been Delivered Successfully. Enjoy Your Purchase!",
    status: "pending",
  },
];

// const TrackShipment = ({ show, handleClose }) => {
//   return (
//     <Modal dialogClassName="track-modal-body" show={show} onHide={handleClose} centered size="lg">

//       <Modal.Body className="track-modal-body">
//         <Card className="card-two p-3 shadow-sm border-0 rounded-4 track-modal-box">
//           <button className="custom-close" onClick={handleClose}>
//     <FontAwesomeIcon icon={faXmark} />
//   </button>
//           <div className="d-flex justify-content-between align-items-center mb-3">
//             <h6 className="mb-0 d-flex align-items-center gap-2">
//               <FontAwesomeIcon
//                 className="location-icon"
//                 icon={faLocationDot}
//               />
//               Track Shipment
//             </h6>

//             <span className="order-box d-inline-flex align-items-center gap-2">
//               <div className="dot"></div>
//               Order Placed
//             </span>
//           </div>

//           <div className="timeline">
//             {stepsData.map((step, i) => (
//               <div key={i} className={`timeline-step ${step.status}`}>
//                 <div className="timeline-dot">
//                   <div className="inner_dot"></div>
//                 </div>

//                 <div className="timeline-content">
//                   <div className="d-flex justify-content-between">
//                     <strong className="order-text">
//                       {step.title}
//                     </strong>

//                     {step.time && (
//                       <small className="text-muted date-time">
//                         {step.time}
//                       </small>
//                     )}
//                   </div>

//                   <div className="text-muted small order-desc">
//                     {step.desc}
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>

//         </Card>
//       </Modal.Body>
//     </Modal>
//   );
// };

const TrackShipment = ({
  show,
  handleClose,
  orderStatusId,
  allStatus,
  updatedAt,
}) => {
  const dispatch = useDispatch();

  const productsdetails = useSelector(
    (state) => state.product.productdetails?.get_order_history,
  );

  const all_order_status = useSelector(
    (state) => state?.common?.all_order_status,
  );

  useEffect(() => {
    dispatch(getAllOrder());
    dispatch(AllOrderStatus());
    dispatch(getProduct());
  }, [dispatch]);

  const stepsData = allStatus?.map((status) => {
    let stepStatus = "pending";

    if (Number(status.id) < Number(orderStatusId)) {
      stepStatus = "done";
    } else if (Number(status.id) === Number(orderStatusId)) {
      stepStatus = "active";
    }

    return {
      title: status.name,
      desc:
        status.name === "Confirmed"
          ? "We have received your order and it is being prepared for processing."
          : status.name === "Processing"
          ? "Your order has been shipped and handed over to our delivery partner."
          : "Your Order Has Been Delivered Successfully. Enjoy Your Purchase!",
      status: stepStatus,

      time:
        stepStatus !== "pending"
          ? new Date(updatedAt).toLocaleString("en-IN", {
              day: "2-digit",
              month: "short",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })
          : null,
    };
  });

  return (
    <Modal
      dialogClassName="track-modal-body"
      show={show}
      onHide={handleClose}
      centered
      size="lg"
    >
      <Modal.Body className="track-modal-body">
        <Card className="card-two p-3 shadow-sm border-0 rounded-4 track-modal-box">
          <button className="custom-close" onClick={handleClose}>
            <FontAwesomeIcon icon={faXmark} />
          </button>

          <div className="d-flex justify-content-between align-items-start mb-2 mt-5">
            <h6 className="mb-0 d-flex align-items-start gap-2">
              <FontAwesomeIcon className="location-icon" icon={faLocationDot} />
              Track Shipment
            </h6>

            <span className="order-box d-inline-flex align-items-start gap-2">
              <div className="dot"></div>
              {/* Order Placed */}
              {
                allStatus?.find(
                  (item) => Number(item.id) === Number(orderStatusId),
                )?.name
              }
            </span>
          </div>

          <div className="timeline">
            {stepsData?.map((step, i) => (
              <div key={i} className={`timeline-step ${step.status}`}>
                <div className="timeline-dot">
                  <div className="inner_dot"></div>
                </div>

                <div className="timeline-content">
                  <div className="d-flex justify-content-between">
                    <strong className="order-text">{step.title}</strong>

                    {/* {step.time && (
                      <small className="text-muted date-time">
                        {step.time}
                      </small>
                    )} */}
                  </div>

                  <div className="text-muted small order-desc">{step.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </Card>
      </Modal.Body>
    </Modal>
  );
};

export default TrackShipment;
